import styled from 'styled-components';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface GroupBoxProps {
  widthPercentage?: number;
  color?: string;
  first?: boolean;
  last?: boolean;
  selected?: boolean;
}

export const ServiceGroupColorBar = styled.div<GroupBoxProps>`
  border: ${(props) => (props.selected ? '2px solid #000' : 'none')};
  cursor: pointer;
  height: 20px;
  width: ${(props) => (props.widthPercentage ? `${props.widthPercentage}%` : '100%')};
  background: ${(props) => props.color || '#000'};
  border-radius: ${(props) => (props.first ? '20px 0 0 20px' : props.last ? '0 20px 20px 0' : '0')};
  @media only screen and (max-width: 1728px) {
    height: 12px;
  },
`;

interface StackContainerProps {
  selected?: boolean;
}

interface IconProps {
  isOpen: boolean;
}

export const StackContainer = styled.div<StackContainerProps>`
  background: ${(props) => (props.selected ? 'rgb(101 130 164 / 15%)' : 'transparent')};
  padding: 2px 5px;
  cursor: pointer;
  border-radius: 8px;
`;

interface ColorIndicatorProps {
  color?: string;
}

export const ColorIndicator = styled.span<ColorIndicatorProps>`
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: ${(props) => props.color || '#000'};
  margin-right: 8px;
`;

export const CloseSummaryIcon = styled(ArrowDropDownIcon)<IconProps>(({ isOpen }) => ({
  background: `${isOpen ? '#0C7CBB' : '#EBEFF3'}`,
  color: `${isOpen ? 'white' : 'black'}`,
  width: '3rem',
  height: '3rem',
  borderRadius: '5px',
}));

export const SummaryBackgroundStyle = {
  p: 1,
  background: '#f8fbfd',
  border: '0.1rem solid #d6dce4',
  // borderTop: '0.1rem solid #d6dce4',

  '@media only screen and (max-width: 1728px)': {
    padding: 0,
  },
};
